import { z } from "zod";

export const DirectoryTabValues = {
  ALL: "all",

  TOP_PICKS: "top-picks",

  REQUESTS: "requests",

  CONNECTED: "connected",
} as const;

export const DirectoryTabSchema = z.enum(DirectoryTabValues);

export type DirectoryTabType =
  (typeof DirectoryTabValues)[keyof typeof DirectoryTabValues];

export const DirectoryTab = {
  ALL: DirectoryTabValues.ALL,
  TOP_PICKS: DirectoryTabValues.TOP_PICKS,
  REQUESTS: DirectoryTabValues.REQUESTS,
  CONNECTED: DirectoryTabValues.CONNECTED,

  DEFAULT: DirectoryTabValues.ALL,
} as const;
